import React, { PureComponent } from 'react';
import partial from 'lodash/partial';

import { headerHeight } from '../../base-styles/vars';
import Button from '../../components/Button';
import SearchResultCard from '../EventList/components/SearchResultCard';

import {
  container,
  singlePin,
  selectedPin,
  searchAreaButton,
  zoomControl,
  popupCard,
  loadingDiv,
  spinner,
  popup,
} from './styles.module.css';

const defaultMapStyle = {
  height: `calc(var(--vh, vh) * 100 - ${headerHeight}`,
  width: 'calc(100vw - (100vw - 100%))', // full width minus potential scrollbar
};

const animationOptions = { animate: true, essential: true };

class EventMapMapbox extends PureComponent {
  render() {
    const {
      isMapMoved,
      ReactMapboxGl,
      Map,
      fitBounds,
      events,
      loading,
      zoom,
      center,
      onMarkerClick,
      clusterMarker,
      getUnwrappedMap,
      selectedEvent,
      selectedEventId,
      hoverEventId,
      onSearchMap,
      isMobile,
      onZoomClick,
      mapStyle,
      onMapClick,
    } = this.props;

    const zoomPadding = isMobile ? 50 : 250;

    return (
      <div className={container}>
        {(isMapMoved || loading) && (
          <Button
            className={searchAreaButton}
            onClick={onSearchMap}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Search this area'}
          </Button>
        )}

        <Map
          // monochrome black and white - mapbox://styles/mapbox/light-v9
          // we're using default street view - can be customized in mapbox https://studio.mapbox.com
          // eslint-disable-next-line react/style-prop-object
          style="mapbox://styles/mapbox/streets-v11?optimize=true"
          center={center}
          zoom={zoom}
          onClick={onMapClick}
          movingMethod="jumpTo"
          animationOptions={animationOptions}
          fitBounds={fitBounds}
          containerStyle={mapStyle ?? defaultMapStyle}
          onStyleLoad={(map) => getUnwrappedMap(map)}
        >
          {!isMobile && (
            <ReactMapboxGl.ZoomControl
              className={zoomControl}
              position="top-left"
              onControlClick={onZoomClick}
            />
          )}
          <ReactMapboxGl.Cluster
            ClusterMarkerFactory={clusterMarker}
            zoomOnClick
            radius={25}
            maxZoom={12}
            zoomOnClickPadding={zoomPadding}
          >
            {events &&
              events.map((event, idx) => (
                <ReactMapboxGl.Marker
                  key={event.id}
                  className={
                    selectedEventId === event.id ||
                    hoverEventId?.toString() === event.id.toString()
                      ? selectedPin
                      : singlePin
                  }
                  coordinates={event.coordinates}
                  data-feature={event}
                  onClick={partial(
                    onMarkerClick,
                    event.id,
                    idx,
                    event.coordinates,
                  )}
                  anchor="bottom"
                />
              ))}
          </ReactMapboxGl.Cluster>
          {!isMobile && selectedEvent?.id && (
            <ReactMapboxGl.Popup
              className={popup}
              key={selectedEvent?.id}
              coordinates={selectedEvent?.coordinates}
              anchor="top"
            >
              <div className={popupCard}>
                <SearchResultCard
                  className={popupCard}
                  key={selectedEvent.id}
                  event={selectedEvent}
                />
              </div>
            </ReactMapboxGl.Popup>
          )}
        </Map>

        {loading && (
          <div className={loadingDiv}>
            <div className={spinner} />
          </div>
        )}
      </div>
    );
  }
}

export default EventMapMapbox;
